module.exports = __webpack_public_path__ + "img/dongji_ps_18.645969e9.jpg";